export { default as CollectionMarketingCard } from './CollectionMarketingCard';
